import {
    DataLayerEventName,
    LiveBlogEvents,
    SharingEvent,
    WebLink,
} from '@news-mono/web-common'
import { EventPostV4DTO } from '@west-australian-newspapers/publication-types'
import React, { FC, useState } from 'react'
import {
    StyledMilestone,
    StyledMilestonesContainer,
    StyledMilestonesTimeline,
    StyledMilestonesTitle,
    StyledMilestoneTimestamp,
    StyledMilestoneTitle,
    StyledShowMoreButton,
} from './LiveEventMilestones.styled'

interface LiveEventMilestonesProps {
    milestones: EventPostV4DTO[]
    enableTruncation?: boolean
    onEvent: (event: LiveBlogEvents | SharingEvent) => void
}

export const LiveEventMilestones: FC<LiveEventMilestonesProps> = ({
    milestones,
    onEvent,
    enableTruncation = true,
}) => {
    const [truncatedList, setTruncatedList] = useState(
        !!enableTruncation && milestones.length > 6,
    )
    const [dimMilestones, setDimMilestones] = useState(false)

    return (
        <StyledMilestonesContainer>
            <StyledMilestonesTitle>Key Events</StyledMilestonesTitle>
            <StyledMilestonesTimeline restrictedHeight={truncatedList}>
                {milestones.map((m, i) => (
                    <WebLink
                        key={m.id}
                        to={m._self}
                        openExternalInNewWindow={false}
                    >
                        <StyledMilestone
                            dimmed={dimMilestones}
                            onMouseEnter={() => setDimMilestones(true)}
                            onMouseLeave={() => setDimMilestones(false)}
                            onClick={() => {
                                onEvent({
                                    type: DataLayerEventName.milestoneClick,
                                    originator: 'LiveEvent',
                                    payload: {
                                        publicationId: m.eventId,
                                        postId: m.id,
                                    },
                                })
                            }}
                        >
                            <StyledMilestoneTimestamp
                                timestampStyle="relative"
                                time={m.publishedDate}
                            />
                            <StyledMilestoneTitle>
                                {m.title}
                            </StyledMilestoneTitle>
                        </StyledMilestone>
                    </WebLink>
                ))}
            </StyledMilestonesTimeline>
            <StyledShowMoreButton
                id="showmore"
                isVisible={milestones.length > 6}
                onClick={() => setTruncatedList(!truncatedList)}
            >
                <span>{truncatedList ? '＋' : '－'} </span>{' '}
                {`Show ${truncatedList ? 'more' : 'less'}`}
            </StyledShowMoreButton>
        </StyledMilestonesContainer>
    )
}
